export const FormLink = ({_key,name,value,input,change}:any) => {
    return(
        <>
        <label htmlFor={`fileInput${_key}`} className="form-label">{name}</label>
        <div className="input-group mb-3" id={`fileInput${_key}`}>
            <span className={`input-group-text ${value !== ' ' ? "bg-success" : "bg-danger"}`}>{value !== ' ' ? "دارای لینک" : "فاقد لینک"}</span>
            <input type="text" className="form-control" onChange={change} name={input} id={`textInput${_key}`} placeholder="لینک" defaultValue={value}/>
        </div>
        </>
    )
}